import { render, staticRenderFns } from "./action-details.vue?vue&type=template&id=55761fc4&scoped=true"
import script from "./action-details.vue?vue&type=script&lang=js"
export * from "./action-details.vue?vue&type=script&lang=js"
import style0 from "./action-details.vue?vue&type=style&index=0&id=55761fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55761fc4",
  null
  
)

export default component.exports